<script>
  // The shared "who-has-it" expand panel for the CardCollection shell (ADR-0010):
  // lists each binder/owner holding the card. Per-version price and quantity
  // render only when present.
  import { navigate } from '../../lib/stores/router.svelte.js';
  import { getBinderColor } from '../../lib/logic/utils.js';
  import { formatPrice } from '../../lib/logic/card-collection-logic.js';
  import NotSharedHere from '../shared/NotSharedHere.svelte';

  let { holders = [], currencySymbol = '$' } = $props();

  function handleBinderClick(e, url) {
    if (!url) return;
    e.preventDefault();
    navigate('binder', { binderUrl: url, shortPath: url });
  }
</script>

<div class="holder-list">
  {#each holders as h, i (i)}
    {@render row(h)}
  {/each}
</div>

{#snippet row(h)}
  {@const color = h.binderUrl ? getBinderColor(h.binderUrl) : 'var(--color-text-muted)'}
  <div class="holder-row">
    <div class="holder-dot" style:background={color}></div>
    {#if h.binderUrl}
      <a
        href={h.binderUrl}
        class="holder-link"
        style:--holder-link-color={color}
        onclick={(e) => handleBinderClick(e, h.binderUrl)}
      >
        {h.binderName || h.ownerName || 'Binder'}
      </a>
    {:else}
      <span class="holder-name">{h.binderName || h.ownerName || 'Binder'}</span>
    {/if}
    {#if h.ownerName && h.binderName}
      <span class="holder-owner">{h.ownerName}</span>
    {/if}
    {#if h.shared === false}<NotSharedHere />{/if}
    <span class="holder-meta">
      {#if formatPrice(h.price, currencySymbol)}
        <span class="holder-price">{formatPrice(h.price, currencySymbol)}</span>
      {/if}
      {#if h.quantity != null}
        <span class="holder-qty">x{h.quantity}</span>
      {/if}
    </span>
  </div>
{/snippet}

<style>
  .holder-list {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
  }

  .holder-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.813rem;
  }

  .holder-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .holder-link {
    color: var(--holder-link-color, var(--color-text));
    text-decoration: none;
    font-weight: 500;
    transition: opacity 0.15s;
  }

  .holder-link:hover {
    opacity: 0.75;
    text-decoration: underline;
  }

  .holder-name {
    color: var(--color-text);
    font-weight: 500;
  }

  .holder-owner {
    color: var(--color-text-muted);
    font-size: 0.75rem;
  }

  .holder-meta {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .holder-price {
    color: var(--color-text-secondary);
    font-size: 0.75rem;
    font-weight: 600;
  }

  .holder-qty {
    color: var(--color-text-muted);
    font-size: 0.75rem;
  }
</style>
